

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  label: function label(props) {return {
      color: props.validationPassed ? colors.neutral[900] : colors.red[500],
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem',
        weight: 500
      },
      letterSpacing: '0.02rem',
      margin: 0
    };},
  list: { padding: 0, margin: 0 },
  listColumn: {
    display: 'flex',
    flex: {
      direction: 'column'
    }
  },
  validationBlock: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem'
    },
    color: colors.red[500],
    display: 'flex',
    alignItems: 'center',
    margin: {
      left: '0.1rem',
      top: '0.8rem',
      right: '0rem',
      bottom: '0rem'
    }
  },
  validationMessage: {
    marginLeft: '0.4rem'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map